"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntlTelInput = _interopRequireDefault(require("react-intl-tel-input"));

var _regex = _interopRequireDefault(require("../utils/regex"));

var _isEmpty = _interopRequireDefault(require("../utils/isEmpty"));

var _utils = require("./utils");

var _TextField = _interopRequireDefault(require("../TextField"));

var _constants = require("./constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var replaceInvalidInput = function replaceInvalidInput(value) {
  if (value) return value.replace(_regex["default"].INVALID_TELEPHONE_CHARACTERS, '');
  return value;
};

var PhoneField = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PhoneField, _React$Component);

  var _super = _createSuper(PhoneField);

  function PhoneField() {
    var _this;

    (0, _classCallCheck2["default"])(this, PhoneField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      defaultCountry: _constants.DEFAULT_COUNTRY,
      loading: true
    });
    return _this;
  }

  (0, _createClass2["default"])(PhoneField, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this2 = this;

        var _this$props, value, fieldId, geoIpLookup, browserLanguage, userLanguage, setDefaultCountry;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, value = _this$props.value, fieldId = _this$props.fieldId, geoIpLookup = _this$props.geoIpLookup;

                if ((0, _isEmpty["default"])(value)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", this.setState({
                  loading: false
                }));

              case 3:
                browserLanguage = window.navigator.userLanguage || window.navigator.language;
                userLanguage = browserLanguage.toLowerCase() === 'pt-br' ? 'br' : _constants.DEFAULT_COUNTRY;

                setDefaultCountry = function setDefaultCountry(defaultCountry) {
                  return _this2.setState({
                    defaultCountry: defaultCountry.toLowerCase(),
                    loading: false
                  });
                };

                if (!geoIpLookup) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 7;
                _context.next = 10;
                return geoIpLookup(setDefaultCountry);

              case 10:
                return _context.abrupt("return", _context.sent);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);
                return _context.abrupt("return", this.setState({
                  defaultCountry: userLanguage,
                  loading: false
                }));

              case 16:
                return _context.abrupt("return", this.setState({
                  defaultCountry: userLanguage,
                  loading: false
                }));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          value = _this$props2.value,
          input = (0, _objectWithoutProperties2["default"])(_this$props2, ["className", "value"]);
      var _this$state = this.state,
          defaultCountry = _this$state.defaultCountry,
          loading = _this$state.loading;

      if (loading) {
        return /*#__PURE__*/React.createElement(_TextField["default"], {
          disabled: true
        });
      }

      return /*#__PURE__*/React.createElement(_reactIntlTelInput["default"], (0, _extends2["default"])({}, input, {
        defaultCountry: defaultCountry,
        value: replaceInvalidInput(value),
        inputClassName: (0, _classnames["default"])(className, 'pp-input')
      }));
    }
  }]);
  return PhoneField;
}(React.Component);

exports["default"] = PhoneField;
(0, _defineProperty2["default"])(PhoneField, "defaultProps", {
  format: true,
  formatOnInit: false,
  separateDialCode: false,
  geoIpLookup: _utils.lookup,
  utilsScript: 'libphonenumber.js',
  defaultCountry: _constants.DEFAULT_COUNTRY,
  preferredCountries: ['us', 'gb', 'br']
});